import fp from 'lodash/fp'
import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'react-loaders'

import * as styles from './styles'

// TODO: Temp solutin before adding splashscreen
const ContentLoaderComponent = ({
  waiting,
  children,
  onlyOverlay,
  fixed,
  wrapperStyles,
}) => {
  const showChildren = !waiting || onlyOverlay

  return (
    <>
      {waiting && (
        <div
          css={[
            styles.container,
            fixed ? styles.fixed : styles.absolute,
            wrapperStyles,
          ]}
        >
          <Loader type="ball-clip-rotate-multiple" />
        </div>
      )}
      {showChildren && (fp.isFunction(children) ? children() : children)}
    </>
  )
}

ContentLoaderComponent.propTypes = {
  waiting: PropTypes.bool.isRequired,
  onlyOverlay: PropTypes.bool,
  fixed: PropTypes.bool,
  message: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  wrapperStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default ContentLoaderComponent
